module.exports = __webpack_public_path__ + "14four/static/media/Pause-Btn.fc7315fe.svg";